import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import {
  AbstractSecurityStorage,
  AuthModule,
  LogLevel,
  OpenIdConfiguration,
  StsConfigHttpLoader,
  StsConfigLoader,
} from 'angular-auth-oidc-client';
import { TokenInterceptor } from './auth-interceptor';
import { environment } from '../../environments/environment';
import { AppEnvironment } from '@env/app-environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MyStorageService } from './auth-storage';

export const httpLoaderFactory = (httpClient: HttpClient, customStorage: MyStorageService) => {
  let configUrl: string = '/assets/config/app.config.json';
  if (environment.production == false) {
    configUrl = '/assets/config/app.config.Dev.json';
  }

  const config: Observable<OpenIdConfiguration> = httpClient
    .get<AppEnvironment>(`${window.location.origin}${configUrl}`)
    .pipe(
      map((customConfig: AppEnvironment) => {
        return {
          triggerAuthorizationResultEvent: true,
          authority: customConfig.authority,
          redirectUrl: customConfig.redirectUrl,
          clientId: customConfig.clientId,
          responseType: 'code',
          scope: 'openid profile email offline_access',
          postLogoutRedirectUri: window.location.origin,
          silentRenew: true,
          postLoginRoute: '/home',
          forbiddenRoute: '/forbidden',
          unauthorizedRoute: '/forbidden',
          logLevel: LogLevel.Warn,
          historyCleanupOff: true,
          useRefreshToken: true,
          storage: customStorage,
        };
      })
    );

  return new StsConfigHttpLoader(config.toPromise());
};

@NgModule({
  imports: [
    HttpClientModule,
    AuthModule.forRoot({
      storage: MyStorageService,
      loader: {
        provide: StsConfigLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient, MyStorageService],
      },
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: AbstractSecurityStorage, useClass: MyStorageService },
  ],
  exports: [AuthModule],
})
export class AuthConfigModule {}
